/**
 * Owner 2026-11-04 (migration 1630): upcoming events with no active Lead / Event Rep on their Sales Reps list -- the
 * definition day start / close use. Admins, managers and staff see every event; Regional / Territory Managers only the
 * events they can see. Self-service events are never listed.
 */
import { supabase } from "./supabase";

export interface MissingLeadEvent {
  event_id: string;
  title: string;
  type: string;
  status: string;
  start_time: string;
  timezone: string;
  location_city: string | null;
  location_state: string | null;
  /** no_lead = nobody is Lead on the list; lead_seat_inactive = the Lead's seat or person is inactive / vacant */
  why: "no_lead" | "lead_seat_inactive";
  lead_name: string | null;
  territory_manager_name: string | null;
  regional_manager_name: string | null;
  created_by_name: string | null;
  total_count: number;
}

export const MISSING_LEAD_ROLES = [
  "superadmin",
  "admin",
  "manager",
  "regionalmanager",
  "territorymanager",
  "staff",
];

export function canSeeMissingLead(role: string | null | undefined): boolean {
  return MISSING_LEAD_ROLES.includes(
    (role ?? "").toLowerCase().replace(/_/g, ""),
  );
}

export async function getEventsMissingLead(
  days = 60,
  limit = 500,
): Promise<MissingLeadEvent[]> {
  const { data, error } = await supabase.rpc("events_missing_lead", {
    p_days: days,
    p_limit: limit,
  });
  if (error) {
    throw new Error(error.message);
  }
  return (data ?? []) as MissingLeadEvent[];
}
